module.exports = __webpack_public_path__ + "static/WEDDING E&M-208-48e3d42508b724d708f36f3c7e595e4d.jpg";